@if (!erreurRecuperation()) {
  <div class="sites">
    <app-liste-generique [proprietesAffichees]="proprietesAfficheesSites" [listeObjets]="tabSites()" (clicObjetEvent)="ouvrirModale($event)"
    [triParDefaut]="{'prop':'region', 'sousProp':'nom', 'type':'string'}" [listeModifiee]="listeModifiee"></app-liste-generique>
    <div class="footer">
      <button *showIfHasRole="'create_site'" class="btn btn-primary" (click)="ouvrirModaleAjout()"><i class="fas fa-plus" style="padding-right: 5px;"></i>{{'GLOBAL.AJOUTER' | translate}}</button>
    </div>
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}
